var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListedItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#paint0_linear_5480_143800)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9824 15.8366C23.9515 15.6822 23.8772 15.5397 23.7683 15.4259C23.6594 15.3121 23.5203 15.2317 23.3674 15.1941L17.6507 13.7641L19.7649 8.82994C19.8385 8.65871 19.8525 8.46771 19.8046 8.28758C19.7567 8.10745 19.6497 7.94863 19.5007 7.83661C19.352 7.72385 19.1696 7.6645 18.9831 7.66813C18.7965 7.67175 18.6166 7.73815 18.4724 7.85661L9.30569 15.3566C9.18613 15.4544 9.0961 15.5835 9.04566 15.7296C8.99523 15.8756 8.98637 16.0327 9.02009 16.1835C9.0538 16.3342 9.12875 16.4727 9.23658 16.5833C9.3444 16.6939 9.48085 16.7724 9.63069 16.8099L15.2299 18.2108L12.4424 23.0891C12.3705 23.2158 12.333 23.3592 12.3337 23.5049C12.3344 23.6506 12.3733 23.7936 12.4465 23.9196C12.5196 24.0456 12.6245 24.1503 12.7507 24.2231C12.8769 24.296 13.02 24.3346 13.1657 24.3349C13.3461 24.3352 13.5216 24.2767 13.6657 24.1683L23.6657 16.6683C23.7917 16.5737 23.8883 16.4454 23.9443 16.2982C24.0004 16.1511 24.0136 15.991 23.9824 15.8366V15.8366Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5480_143800",
    x1: 0.5,
    y1: 16,
    x2: 32.4457,
    y2: 15.9795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F51919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#770001"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListedItems);
export default __webpack_public_path__ + "static/media/listed-items.e6abce19b20bbfee9e2967ae13742af0.svg";
export { ForwardRef as ReactComponent };